const periodEndStatus = {
  Pending: 1,
  InProcess: 2,
  Finalized: 3,
  NotFinalized: 4,
};

export default periodEndStatus;
